import { EmailAuthProvider, FacebookAuthProvider, GoogleAuthProvider } from 'firebase/auth';

export const UI_CONFIG = {
    // Popup signin flow rather than redirect flow.
    signInFlow: 'popup',
    // We will display Google and Facebook as auth providers.
    signInOptions: [GoogleAuthProvider.PROVIDER_ID, FacebookAuthProvider.PROVIDER_ID, EmailAuthProvider.PROVIDER_ID],
    callbacks: {
        // Avoid redirects after sign-in.
        signInSuccessWithAuthResult: () => false,
    },
    credentialHelper: 'googleyolo',
    tosUrl: process.env.PUBLIC_TOS_URL,
    privacyPolicyUrl: process.env.PUBLIC_PRIVACY_URL,
} as const;
